import React from 'react';

import { Box } from '@mui/material';
import MenuList from 'modules/Home/components/MenuList';
import NewsList from 'modules/Home/components/NewsList';

function HomePage() {
	return (
		<Box sx={{ display: 'flex', flexDirection: 'column' }}>
			<MenuList />
			<NewsList />
		</Box>
	);
}
export default HomePage;
